query getReview {
    g2Review {
        reviewLink
    }
}
